"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports._ = void 0;
const react_peg_1 = require("react-peg");
const basic_1 = require("../basic");
// white space
function _() {
    return (react_peg_1.ReactPeg.createChunk("repeat", { type: "*" },
        react_peg_1.ReactPeg.createChunk("or", null,
            react_peg_1.ReactPeg.createChunk(basic_1.MultiLineComment, null),
            react_peg_1.ReactPeg.createChunk("set", null, " \\t\\n\\r"))));
}
exports._ = _;
const Text = (content) => {
    return (react_peg_1.ReactPeg.createChunk("list", null,
        react_peg_1.ReactPeg.createChunk(_, null),
        react_peg_1.ReactPeg.createChunk("text", null, content),
        react_peg_1.ReactPeg.createChunk(_, null)));
};
exports.Text = Text;
